export enum Cobrar {
  NAO = "NAO",
  SIM = "SIM",
}
